import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { shareReplay } from 'rxjs';
import { TournamentsResponse } from '../../all-tournaments/models/api/responses/tournaments.response';
import { Filter } from '../../all-tournaments/store/actions/allTournaments.action';
import { endpoints } from '../../utils/endpoints';
import { FetchHomeTournamentsRequest } from '../models/api/requests/home.request';
import { HomeTournament } from '../models/enums/home.enum';
import { TournamentState } from 'src/app/tournament/models/enums/tournaments.enum';

@Injectable({
    providedIn: 'root',
})
export class HomeService {
    private http = inject(HttpClient);


    fetchHomeTournaments(request: FetchHomeTournamentsRequest) {
        const filters: Filter = {};
        switch (request.type) {
            case HomeTournament.PC:
                filters.gamePlatform = 'PC';
                filters.isEndlessSeries = 'false';
                break;
            case HomeTournament.Mobile:
                filters.gamePlatform = 'Mobile';
                filters.isEndlessSeries = 'false';
                break;
            case HomeTournament.Console:
                filters.gamePlatform = ['XBox', 'PS'];
                filters.isEndlessSeries = 'false';
                break;
            case HomeTournament.isEndlessSeries:
                filters.isEndlessSeries = 'true';
                break;
        }

        filters.state = [TournamentState.RegistrationStarted, TournamentState.EarlyAccessStarted];
        filters.sortByGeneral = 'plannedStart';
        filters.createdByAdmin = 'true';

        return this.http
            .get<TournamentsResponse>(
                endpoints.tournaments.children.getAllTournaments({
                    page: request.page,
                    filters,
                })
            )
            .pipe(shareReplay());
    }
}
